import AddTourContainer from './AddTourContainer.js';
import ChangeDayTypeContainer from './ChangeDayTypeContainer.js';
import EditTourContainer from './EditTourContainer.js';
import AddAssignmentContainer from './AddAssignmentContainer.js';
import EditAssignmentContainer from './EditAssignmentContainer.js';


const LiveScheduleUpdateForm = {
  AddTour: AddTourContainer,
  ChangeDayType: ChangeDayTypeContainer,
  EditTour: EditTourContainer,
  AddAssignment: AddAssignmentContainer,
  EditAssignment: EditAssignmentContainer
};

export default LiveScheduleUpdateForm;
